// Shared static data — clients, training, consulting

export const CLIENTS = [
  { name: "HSBC", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/odp5s41d_HSBC_BIG.svg", region: "Hong Kong" },
  { name: "Standard Chartered", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/o9jlizh4_STAN.L_BIG.svg", region: "Hong Kong" },
  { name: "Jardine Matheson", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/mj6mrmn9_J36.SI_BIG.svg", region: "Hong Kong" },
  { name: "Jardine Engineering Corporation", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/p94ep53o_JEC.webp", region: "Hong Kong" },
  { name: "Jardine Service Centre — China", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/horadksv_JSC.webp", region: "Greater China" },
  { name: "Jardine Service Centre — Philippines", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/horadksv_JSC.webp", region: "Philippines" },
  { name: "DFI Retail Group", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/3np1qe9y_D01.SI_BIG.svg", region: "Asia Pacific" },
  { name: "Zung Fu", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/8vjf40li_hk-zung-fu-logo.png", region: "Hong Kong" },
  { name: "Gammon Construction", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/nj8coz8o_Gammon.webp", region: "Hong Kong" },
  { name: "Tan Tock Seng Hospital", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/ccqmsq0u_TTS.webp", region: "Singapore" },
  { name: "Eastern Health", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/0ahfywp1_OIP%20%285%29.webp", region: "Australia" },
  { name: "Mercy Health", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/r6a6ux5g_OIP%20%286%29.webp", region: "Australia" },
  { name: "Australian Unity", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/uzd1pqbq_Australian%20UNity.jpg", region: "Australia" },
  { name: "GE Money", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/es6p0era_GE_Money.svg", region: "Australia" },
  { name: "Mallesons", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/1s1di3mv_Mallesons_logo.png", region: "Australia" },
  { name: "Christchurch City Council", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/te8kqcnd_Christchurch-City-Council-Logo.webp", region: "New Zealand" },
  { name: "Middlemore Hospital", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/n6x4fyoc_MIddlemore%20hospital.webp", region: "New Zealand" },
  { name: "Northern Health", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/ln6ph8jr_Northern%20Health%20logo.svg", region: "Australia" },
  { name: "Safer Care Victoria", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/jsapr09b_OIP%20%289%29.webp", region: "Australia" },
  { name: "Monash Health", url: "https://customer-assets.emergentagent.com/job_lean-six-sigma-asia/artifacts/7afkqvbd_R.png", region: "Australia" },
];

export const TRAINING_PROGRAMS = [
  {
    id: "yellow-belt",
    code: "LSS-YB",
    title: "Yellow Belt",
    duration: "2 days",
    level: "Foundation",
    audience: "Team members & frontline staff supporting improvement projects.",
    description:
      "An introduction to Lean Six Sigma vocabulary, DMAIC and the seven wastes — grounded in industry-specific simulations that mirror the daily reality of banks, hospitals, construction, retail and manufacturing. Learners leave able to identify improvement opportunities and contribute to projects led by Green or Black Belts.",
    outcomes: [
      "Understand DMAIC at a conceptual level",
      "Identify the 7 wastes (TIMWOOD) in your workflow",
      "Apply the tools in an industry-specific simulation tailored to your sector",
      "Run small Kaizen tickets independently",
      "Yellow Belt certificate of completion",
    ],
  },
  {
    id: "green-belt",
    code: "LSS-GB",
    title: "Green Belt",
    duration: "5 days + project",
    level: "Practitioner",
    audience: "Process owners, supervisors and improvement project leads.",
    description:
      "Hands-on certification covering the full DMAIC toolkit, statistical thinking, hypothesis testing and Minitab fundamentals — culminating in a workplace project review.",
    outcomes: [
      "Lead departmental improvement projects",
      "Apply SIPOC, VOC, FMEA, control charts",
      "Perform hypothesis testing & DOE basics",
      "Internationally recognised certification",
    ],
  },
  {
    id: "black-belt",
    code: "LSS-BB",
    title: "Black Belt",
    duration: "10 days + 2 projects",
    level: "Advanced",
    audience: "Full-time improvement leaders and programme managers.",
    description:
      "The complete advanced statistical and change-leadership programme. Black Belts deploy enterprise-wide initiatives, mentor Green Belts and own multi-million dollar savings portfolios.",
    outcomes: [
      "Lead enterprise transformation portfolios",
      "Master DOE, Multivariate, Regression, Reliability",
      "Mentor Green Belt project pipelines",
      "Two completed projects, signed-off by Master Black Belt",
    ],
  },
  {
    id: "lean-foundations",
    code: "LN-F",
    title: "Lean Foundations",
    duration: "1 day",
    level: "Foundation",
    audience: "Anyone new to operational excellence or value-stream thinking.",
    description:
      "A pragmatic primer on Lean principles — flow, pull, perfection — applied to service and manufacturing contexts across the Asia-Pacific region.",
    outcomes: [
      "Identify value vs. waste in any process",
      "Read and draft a basic Value Stream Map",
      "Apply 5S in your own work area",
      "Build a continuous-improvement mindset",
    ],
  },
  {
    id: "lean-practitioner",
    code: "LN-P",
    title: "Lean Practitioner",
    duration: "4 days + project",
    level: "Practitioner",
    audience: "Operations supervisors, lean coaches and process engineers.",
    description:
      "Apply Lean tools end-to-end — Kanban, SMED, TPM, Heijunka — to deliver a measurable reduction in lead time, inventory or defects in a sponsored workplace project.",
    outcomes: [
      "Run a full Value Stream Mapping workshop",
      "Design and stabilise pull / Kanban systems",
      "Deliver a Kaizen event from charter to control",
      "Lean Practitioner certification",
    ],
  },
  {
    id: "lean-leadership",
    code: "LN-L",
    title: "Lean Leadership",
    duration: "3 days",
    level: "Executive",
    audience: "Senior leaders, GMs and transformation sponsors.",
    description:
      "How to create the cultural conditions for excellence: Hoshin Kanri, Lean daily management, Gemba leadership and obeya. For executives accountable for sustaining results.",
    outcomes: [
      "Deploy Hoshin Kanri / strategy A3s",
      "Establish Lean daily management cadence",
      "Coach via Gemba walks & A3 thinking",
      "Build a culture of disciplined improvement",
    ],
  },
];

export const CONSULTING_SERVICES = [
  {
    id: "operational-excellence",
    title: "Operational Excellence",
    tagline: "Build a system, not a project.",
    summary:
      "We help leadership teams design and embed an operating system — the daily management, capability programme and improvement governance — that makes excellence repeatable across every site, every shift, every quarter.",
    pillars: [
      { title: "Operating System Design", body: "Tier 1–4 daily management, escalation and visual management." },
      { title: "Capability Build", body: "Belt programmes, coach networks and certification pathways." },
      { title: "Project Pipeline", body: "Value-linked portfolio, governance and benefit tracking." },
      { title: "Cultural Embedment", body: "Behaviour design, leader-standard work and reinforcement." },
    ],
    outcomes: [
      "Self-sustaining improvement system",
      "Belt-certified internal coach network",
      "Tracked benefits in P&L, not slideware",
      "Year-on-year compounding performance",
    ],
  },
  {
    id: "ai-agency",
    title: "AI Automation",
    tagline: "Built on enterprise experience — not theory.",
    summary:
      "We help leadership teams move past AI experimentation into measurable value — designing strategy, governance and operating models, prioritising the use cases that pay back, and deploying generative AI and process automation that lands inside daily workflows.",
    pillars: [
      {
        title: "AI Strategy & Operating Model",
        body: "Enterprise AI vision and roadmap, governance and risk frameworks, and operating-model design (centralised, federated or hybrid) — built on the data and architecture you actually have.",
      },
      {
        title: "Use-Case Discovery & Prioritisation",
        body: "Rapid discovery workshops, value-based prioritisation, feasibility and risk screens, and investment-grade business cases — so you fund the AI work that matters.",
      },
      {
        title: "Deployment & Integration",
        body: "Generative AI workflow automation, knowledge retrieval, customer and employee-facing assistants, and AI-enabled reporting — embedded inside your processes, not bolted on.",
      },
      {
        title: "AI Centre of Excellence",
        body: "CoE design, guardrails and standards, capability uplift and adoption — the operating system that scales AI safely after our team has left the room.",
      },
    ],
    outcomes: [
      "Funded AI portfolio with quantified P&L impact",
      "Production-ready GenAI and process-automation rollouts",
      "Governance, risk and compliance you can defend",
      "An internal CoE that scales after we leave",
    ],
  },
  {
    id: "business-review",
    title: "Business Review",
    tagline: "An honest look at where the value is — and isn't.",
    summary:
      "A structured 4–6 week diagnostic across strategy, operations, finance and people. We surface the 5–7 issues that actually matter and the value at stake against each.",
    pillars: [
      { title: "Commercial Diagnostic", body: "Pricing, margin, channel and customer-mix analysis." },
      { title: "Operational Diagnostic", body: "Throughput, OEE, lead time, quality and cost-to-serve." },
      { title: "Organisational Diagnostic", body: "Span, layers, capability, culture & leadership signal." },
      { title: "Value-at-Stake Map", body: "Quantified opportunities prioritised by impact and effort." },
    ],
    outcomes: [
      "Quantified opportunity map (3–7 themes)",
      "Investment thesis or recovery plan",
      "Board-ready synthesis pack",
      "Implementation roadmap with owners",
    ],
  },
  {
    id: "business-turnaround",
    title: "Business Turnaround",
    tagline: "Stabilise. Restructure. Restart growth.",
    summary:
      "When margins are eroding, cash is tight or operations are unravelling, we deploy a turnaround team on the ground — fast. Our specialists combine financial diagnostics, operational restructuring and stakeholder management to stop the bleed and chart a credible path back to profit.",
    pillars: [
      {
        title: "Crisis Stabilisation",
        body: "Immediate cash, working-capital and supplier interventions in the first 30 days. We secure the runway so leadership can think.",
      },
      {
        title: "Operational Restructuring",
        body: "Footprint, headcount, SKU and process simplification — quantified and sequenced for speed and safety.",
      },
      {
        title: "Performance Reset",
        body: "New KPI architecture, daily management and accountability rhythms that survive after we leave.",
      },
      {
        title: "Stakeholder Management",
        body: "Banks, boards, regulators, unions — we manage the room while leadership manages the business.",
      },
    ],
    outcomes: [
      "Cash runway extended in first 60 days",
      "EBITDA margin recovery roadmap",
      "Restructured cost base & SKU portfolio",
      "Operating rhythm that prevents relapse",
    ],
  },
];

export const STATS = [
  { value: "20+", label: "Years across APAC" },
  { value: "5,000+", label: "Practitioners certified" },
  { value: "USD 480M+", label: "Verified client benefits" },
  { value: "94%", label: "Client repeat-engagement rate" },
];

export const TESTIMONIALS = [
  {
    quote:
      "OpExcellence rebuilt our daily management across 14 sites. Twelve months in, OEE is up 11 points and the system is running without their team in the room.",
    name: "Group Operations Director",
    company: "APAC Manufacturing Group",
  },
  {
    quote:
      "Their Black Belt curriculum is the most pragmatic I've seen in twenty years of Lean Six Sigma. Our cohort delivered USD 6.2M in verified savings during certification alone.",
    name: "VP, Continuous Improvement",
    company: "Regional Banking Group",
  },
  {
    quote:
      "The turnaround team got to site within a week. Cash runway was extended in 45 days and we hit our restructuring milestones two months early.",
    name: "Chief Restructuring Officer",
    company: "ASX-listed Healthcare Provider",
  },
];

export const CONTACT_INFO = {
  email: "info@opexcellence.hk",
  phone: "+852 5728 5551",
  address: "L13 Western Commercial Building, 29–31 Des Voeux Rd West, Sheung Wan, Hong Kong",
  hours: "Mon–Fri · 09:00–18:00 HKT",
  regions: ["Hong Kong SAR", "Singapore", "Australia", "New Zealand", "Greater China", "Southeast Asia"],
};
